import { BoomFinanceVerificationSettings } from "shared/types";
import { Step } from "../../types";

type LenderSelectionStep = Step & {
  settings?: BoomFinanceVerificationSettings;
};

const hasLenders = (jsonSchema: unknown) => {
  const schema = jsonSchema as
    | { properties?: { lender_ids?: { items?: { oneOf?: unknown[] } } } }
    | undefined;
  return Boolean(schema?.properties?.lender_ids?.items?.oneOf?.length);
};

export const canDeclineFinancing = (step: Step | undefined) => {
  if (!step) return false;
  const { settings, json_schema } = step as LenderSelectionStep;
  return (
    settings?.no_financing_option_enabled !== false || !hasLenders(json_schema)
  );
};
